export default {
  token: function(valor) {
    if (!valor) {
      return localStorage.getItem('token');
    }

    localStorage.setItem('token', valor);
  },
  usuario: function(valor) {
    if (!valor) {
      return JSON.parse(localStorage.getItem('u'));
    }

    localStorage.setItem('u', JSON.stringify(valor));
  },
  senhaCriada: function (valor) {
    if (!valor) {
      return JSON.parse(localStorage.getItem('senhaCriada'));
    }

    localStorage.setItem('senhaCriada', JSON.stringify(valor));
  },
  termoLGPD: function (valor) {
    if (!valor) {
      return localStorage.getItem('termoLGPD');
    }

    localStorage.setItem('termoLGPD', valor);
  },
  tipoItemCompra: function (valor) {
    if (!valor) {
      return localStorage.getItem('tipoItemCompra');
    }

    localStorage.setItem('tipoItemCompra', valor);
  },
  termoFornecedor: function (valor) {
    if (!valor) {
      return localStorage.getItem('termoFornecedor');
    }

    localStorage.setItem('termoFornecedor', valor);
  },
  configuracao: function() {
    return JSON.parse(localStorage.getItem('configuracao'));
  },
  destinoPosLogin: function (valor) {
    if (valor === undefined) {
      try {
        return JSON.parse(sessionStorage.getItem('destinoPosLogin'));
      } catch (e) {
        return null;
      }
    }

    if (valor === null) {
      sessionStorage.removeItem('destinoPosLogin');
      return;
    }

    sessionStorage.setItem('destinoPosLogin', JSON.stringify(valor));
  },
  deletarToken: function() {
    localStorage.removeItem('token');
  },
  deletarUsuario: function () {
    localStorage.removeItem('u');
  },
  limpar: function() {
    localStorage.removeItem('token');  
    localStorage.removeItem('u');
    localStorage.removeItem('termoLGPD');
    localStorage.removeItem('termoFornecedor');
    localStorage.removeItem('senhaCriada');
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/js/storage.js